import { getSettingsBookingRulesApi as generatedGetSettingsBookingRulesApi } from '../generated/settingsBookingRules/getSettingsBookingRules';

const getSettingsBookingRulesApi = generatedGetSettingsBookingRulesApi.enhanceEndpoints({
  endpoints: {
    getSettingsBookingRules: {
      providesTags: ['SettingsBooking'],
    },
  },
});

export const { useGetSettingsBookingRulesQuery } = getSettingsBookingRulesApi;
